import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation RetryAgentMessage(
    $tenantId: ID!
    $zoneId: ID!
    $messageId: ID!
    $conversationId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        retryAgentMessage(
          messageId: $messageId
          conversationId: $conversationId
        )
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.validate(
  graphql.transformers.OUT.select<
    graphql.schema.RetryAgentMessageMutation,
    undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'retryAgentMessage',
        graphql.transformers.OUT.always(undefined),
      ),
    ),
  ),
  TypeAsserter.assertIsNotNullish,
  { warnOnly: true },
)

export const executor = graphql.createExecutor<
  graphql.schema.RetryAgentMessageMutation,
  undefined,
  graphql.schema.RetryAgentMessageMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
